import React from 'react'
import '../styles/clientFilter.css'

interface ClientFilterProps {
    clients: string[]
    selectedClient: string
    onClientChange: (client: string) => void
    loading: boolean
}

function ClientFilter({
    clients,
    selectedClient,
    onClientChange,
    loading
}: ClientFilterProps) {
    return (
        <div className='client_filter_container'>
            <div className='client_filter_item'>
                <label htmlFor='client_select'>Cliente:</label>
                <select
                    id='client_select'
                    value={selectedClient}
                    onChange={(e) => onClientChange(e.target.value)}
                    disabled={loading || clients.length === 0}
                    className='client_select'
                >
                    <option value='TODOS'>Todos os Clientes</option>
                    {clients.map((client) => (
                        <option key={client} value={client}>
                            {client}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    )
}

export default ClientFilter
